/**
 * Utilities for managing authentication context (Professional vs Client)
 * Persists user preference in localStorage without storing JWT tokens
 */

export type AuthContext = 'professional' | 'client';

const AUTH_CONTEXT_KEY = 'lastAuthContext';

/**
 * Get the last used authentication context from localStorage
 */
export const getLastAuthContext = (): AuthContext | null => {
    try {
        const context = localStorage.getItem(AUTH_CONTEXT_KEY);
        if (context === 'professional' || context === 'client') {
            return context;
        }
        return null;
    } catch {
        return null;
    }
};

/**
 * Save the authentication context to localStorage
 */
export const saveAuthContext = (context: AuthContext): void => {
    try {
        localStorage.setItem(AUTH_CONTEXT_KEY, context);
    } catch {
        // Silently fail if localStorage is not available
    }
};

/**
 * Clear the saved authentication context
 */
export const clearAuthContext = (): void => {
    try {
        localStorage.removeItem(AUTH_CONTEXT_KEY);
    } catch {
        // Silently fail if localStorage is not available
    }
};
